import React, { useEffect, useState } from 'react';
import './allnotification.scss';
import Navbar from '../landing/header/Navbar';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../utils/ApiUrl';
import axios from 'axios';
import { formatDistanceToNow } from 'date-fns';
import { notificationType } from '../../constants/notification';
import { Link } from 'react-router-dom';
import Loader from '../../hooks/loader';

const Allnotification = () => {
    
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true); // Flag to check if there are more notifications
    const [lastNotificationId, setLastNotificationId] = useState(null); // For pagination
    const navigate = useNavigate();

    const fetchNotifications = async (limit = 10) => {
        try {
            setLoading(true);

            const accessToken = localStorage.getItem('accessToken');
            if (!accessToken) {
                throw new Error('Access token not found');
            }

            const params = { limit };

            // Use `lastNotificationId` for pagination (afterElement or beforeElement, depending on your needs)
            if (lastNotificationId) {
                params.afterElement = lastNotificationId;
            }

            const response = await axios.get(`${API_URL}notifications`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params,
            });

            if (response.data.data.length > 0) {
                setNotifications((prevNotifications) => [
                    ...prevNotifications,
                    ...response.data.data,
                ]);
                setLastNotificationId(response.data.data[response.data.data.length - 1]?.id); // Update last notification ID
                setHasMore(response.data.data.length === limit); // If fewer than limit notifications, stop fetching
            } else {
                setHasMore(false); // No more data to load
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };




    const markAsReadAndNavigate = async (notificationId, taskId, link) => {
        try {
            const accessToken = localStorage.getItem('accessToken');
            if (!accessToken) {
                throw new Error('Access token not found');
            }
            let payload;
            if (notificationId === 'markAllAsRead') {
                payload = {
                    markAllAsRead: true,
                };
            } else {
                payload = { id: notificationId };
            }

            // PATCH request to mark the notification as read
            await axios.patch(
                `${API_URL}notifications`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            fetchNotifications(10);
            notificationId !== 'markAllAsRead' && (link ? navigate(`/${link}`) : navigate(`/similartaskdetail/${taskId}`));
        } catch (err) {
            console.error('Failed to mark notification as read', err);
        }
    };

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
        if (bottom && !loading && hasMore) {
            fetchNotifications(10); // Fetch next batch of notifications
        }
    };

    useEffect(() => {
        fetchNotifications(10); // Initial fetch when component mounts
    }, []);

    return (
        <>
            {loading && <Loader />}
            <section className="notificationmainsection">
                <img src="/assets/importantassets/backshade.png" alt="backshade" className="backshade" />
                <div className="notficationdrop">
                    <div className="notficationupper">
                        <h6 className="upperhead">Notifications</h6>
                        <div className='innerparenttext'>
                            {notifications?.some(notification => !notification.isRead) && (
                                <p onClick={() => markAsReadAndNavigate('markAllAsRead', null, null)} className="markpara cp">Mark all as read</p>
                            )}
                            <Link to="/notificationpreferences" className='preference'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.3333 4.66667H7.33331" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.33331 11.3333H3.33331" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.3333 13.3333C12.4379 13.3333 13.3333 12.4379 13.3333 11.3333C13.3333 10.2288 12.4379 9.33333 11.3333 9.33333C10.2287 9.33333 9.33331 10.2288 9.33331 11.3333C9.33331 12.4379 10.2287 13.3333 11.3333 13.3333Z" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.66669 6.66667C5.77126 6.66667 6.66669 5.77124 6.66669 4.66667C6.66669 3.5621 5.77126 2.66667 4.66669 2.66667C3.56212 2.66667 2.66669 3.5621 2.66669 4.66667C2.66669 5.77124 3.56212 6.66667 4.66669 6.66667Z" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Preferences</Link>
                            <Link to="/notificationpreferences" className='preference formobileview d-none'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.3333 4.66667H7.33331" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.33331 11.3333H3.33331" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.3333 13.3333C12.4379 13.3333 13.3333 12.4379 13.3333 11.3333C13.3333 10.2288 12.4379 9.33333 11.3333 9.33333C10.2287 9.33333 9.33331 10.2288 9.33331 11.3333C9.33331 12.4379 10.2287 13.3333 11.3333 13.3333Z" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.66669 6.66667C5.77126 6.66667 6.66669 5.77124 6.66669 4.66667C6.66669 3.5621 5.77126 2.66667 4.66669 2.66667C3.56212 2.66667 2.66669 3.5621 2.66669 4.66667C2.66669 5.77124 3.56212 6.66667 4.66669 6.66667Z" stroke="#013159" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></Link>
                        </div>
                    </div>

                    <div
                        className="notificationsmain"
                        onScroll={handleScroll} // Handle scroll to fetch more data
                    >
                        {notifications?.map((notification, id) => {
                            const createdAt = new Date(notification?.createdAt);
                            const timeAgo = formatDistanceToNow(createdAt, { addSuffix: true });

                            return (
                                <div
                                    className={notification?.isRead ? 'innernotification' : 'innernotification active'}
                                    key={id}
                                >
                                    <span className="notificationimg">
                                        {notificationType[notification?.type]?.svg}
                                    </span>
                                    <div className="notificationtexts">
                                        <div className="lefttexts">
                                            <h6 className="notificationhead">{notification?.title}</h6>
                                            <p className="notificationpara">{notification?.message}</p>
                                            <div className="timemain">
                                                {!notification?.isRead && <span className="yellowcircle"></span>}
                                                <p className="timemainpara">{timeAgo}</p>
                                            </div>
                                        </div>
                                        <div className="noticiationbtns">
                                            {notificationType[notification?.type]?.buttons?.map((btn, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() =>
                                                        markAsReadAndNavigate(notification?.id, notification?.taskId, btn?.link)
                                                    }
                                                    className={btn?.class}
                                                >
                                                    {btn?.text}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                </div>

                            );
                        })}
                        
                        {/* <div className='innernotification'>
                            <span className='notificationimg'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M4.33337 12.0285C4.33337 12.0285 5.08337 11.3142 7.33337 11.3142C9.58337 11.3142 11.0834 12.7428 13.3334 12.7428C15.5834 12.7428 16.3334 12.0285 16.3334 12.0285V3.45708C16.3334 3.45708 15.5834 4.17137 13.3334 4.17137C11.0834 4.17137 9.58337 2.7428 7.33337 2.7428C5.08337 2.7428 4.33337 3.45708 4.33337 3.45708V12.0285Z" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.33337 17.4095V12.0762" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <div className='notificationtexts'>
                                <div className='lefttexts'>
                                    <h6 className='notificationhead'>Your task was reported and is under review 🔍</h6>
                                    <p className='notificationpara'>It’s been flagged for potentially illegal, offensive, or misleading content. It’s now under review and temporarily hidden. We’ll notify you once a decision is made.</p>
                                    <div className='timemain'>
                                        <p className='timemainpara'>40min ago</p>
                                    </div>
                                </div>
                                <div className='noticiationbtns'>
                                    <button className='viewbtn'>View Details</button>
                                </div>
                            </div>
                        </div>

                        <div className='innernotification'>
                            <span className='notificationimg'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M17.0001 5.07617L7.83341 14.2428L3.66675 10.0762" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <div className='notificationtexts'>
                                <div className='lefttexts'>
                                    <h6 className='notificationhead'>Your task was approved by moderators ✅</h6>
                                    <p className='notificationpara'>Your task passed moderation and is now visible to everyone on the website.</p>
                                    <div className='timemain'>
                                        <p className='timemainpara'>40min ago</p>
                                    </div>
                                </div>
                                <div className='noticiationbtns'>
                                    <button className='viewbtn'>View Details</button>
                                </div>
                            </div>
                        </div>

                        <div className='innernotification'>
                            <span className='notificationimg'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M15.3333 5.07617L5.33325 15.0762" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.33325 5.07617L15.3333 15.0762" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <div className='notificationtexts'>
                                <div className='lefttexts'>
                                    <h6 className='notificationhead'>Your task was not approved and is removed ❌</h6>
                                    <p className='notificationpara'>Moderators reviewed your task and found it in violation of our content guidelines. It has been removed from the website. You can now withdraw a refund.</p>
                                    <div className='timemain'>
                                        <p className='timemainpara'>5min ago</p>
                                    </div>
                                </div>
                                <div className='noticiationbtns'>
                                    <button className='participatebtn'>Withdraw Refund</button>
                                    <button className='viewbtn'>View Details</button>

                                </div>
                            </div>
                        </div>

                        <div className='innernotification'>
                            <span className='notificationimg'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M3.66675 5.40942H17.0001" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.6667 5.40942V15.9094C15.6667 16.6594 14.9048 17.4094 14.1429 17.4094H6.52381C5.7619 17.4094 5 16.6594 5 15.9094V5.40942" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.66675 5.40959V4.07625C7.66675 3.40959 8.33341 2.74292 9.00008 2.74292H11.6667C12.3334 2.74292 13.0001 3.40959 13.0001 4.07625V5.40959" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 9.40942V13.4094" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.6667 9.40942V13.4094" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <div className='notificationtexts'>
                                <div className='lefttexts'>
                                    <h6 className='notificationhead'>The task you reported was removed ✅</h6>
                                    <p className='notificationpara'>Thanks for your report. The task you flagged was reviewed and found to violate our guidelines. It has been removed from the website.</p>
                                    <div className='timemain'>
                                        <p className='timemainpara'>40min ago</p>
                                    </div>
                                </div>
                                <div className='noticiationbtns'>
                                    <button className='participatebtn'>Withdraw Refund</button>
                                    <button className='viewbtn'>View Details</button>

                                </div>
                            </div>
                        </div>

                        <div className='innernotification'>
                            <span className='notificationimg'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M10.3333 17.4096C14.3834 17.4096 17.6667 14.1263 17.6667 10.0763C17.6667 6.02617 14.3834 2.74292 10.3333 2.74292C6.28325 2.74292 3 6.02617 3 10.0763C3 14.1263 6.28325 17.4096 10.3333 17.4096Z" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.3333 2.74292C8.62145 4.7201 7.66663 7.34586 7.66663 10.0763C7.66663 12.8066 8.62145 15.4324 10.3333 17.4096C12.0451 15.4324 13 12.8066 13 10.0763C13 7.34586 12.0451 4.7201 10.3333 2.74292Z" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3 10.0762H17.6667" stroke="#013159" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <div className='notificationtexts'>
                                <div className='lefttexts'>
                                    <h6 className='notificationhead'>The task you reported is back on the website ℹ️</h6>
                                    <p className='notificationpara'>The task you flagged was reviewed and did not violate our content guidelines. It has been reinstated and is now visible again..</p>
                                    <div className='timemain'>
                                        <p className='timemainpara'>40min ago</p>
                                    </div>
                                </div>
                                <div className='noticiationbtns'>
                                    <button className='participatebtn'>Withdraw Refund</button>
                                    <button className='viewbtn'>View Details</button>

                                </div>
                            </div>
                        </div> */}

                        {/* {loading && <p>Loading more...</p>} Loading indicator */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Allnotification;